





















































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import WaterConsentConditionEdit from '@/components/display/water-consent-condition-edit.vue';
import { ConsentCondition, ConsentConditionType, ConsentWithId } from '@/api';
import {
	ConsentConditionModule,
	ConsentConditionTypeModule,
	ConsentConditionWithParams,
	ConsentCouncil,
} from '@/modules';
import WaterConsentConditionTypeVolume from '@/components/display/water-consents/conditions/water-consent-condition-type-volume.vue';
import WaterConsentConditionTypeRollingPeriod from '@/components/display/water-consents/conditions/water-consent-condition-type-rolling-period.vue';
import WaterConsentConditionTypeFixedPeriod from '@/components/display/water-consents/conditions/water-consent-condition-type-fixed-period.vue';
import WaterConsentConditionTypeFixedDate from '@/components/display/water-consents/conditions/water-consent-condition-type-fixed-date.vue';
import WaterConsentConditionType from '@/components/display/water-consents/conditions/water-consent-condition-type';
import Toast from '@/components/display/toast.vue';
import { ApiUtils } from '@/common/ApiUtils';

@Component({
	components: {
		WaterConsentConditionTypeFixedDate,
		WaterConsentConditionTypeFixedPeriod,
		WaterConsentConditionTypeRollingPeriod,
		WaterConsentConditionTypeVolume,
		WaterConsentConditionEdit,
	},
})
export default class WaterConsentConditionEditModal extends Vue {
	private readonly toast: Toast = new Toast();
	private readonly consentConditionModule: ConsentConditionModule = new ConsentConditionModule();
	private readonly consentConditionTypeModule: ConsentConditionTypeModule = new ConsentConditionTypeModule();

	@Prop({ required: true })
	public modalId!: string;

	@Prop({ required: true })
	public consent!: ConsentWithId & ConsentCouncil & { active?: boolean; consentconditions?: any[] };

	@Prop({ required: true })
	public consentCondition!: ConsentCondition;

	protected isEditing: boolean = false;
	protected consentConditionType?: ConsentConditionType | null = null;
	protected consentConditionTypes: { text?: string; value: any; disabled?: boolean }[] = [];

	public formValid: boolean = false;

	public async mounted() {
		const consentConditionTypes = await this.consentConditionTypeModule.getConsentConditionTypes();
		if (consentConditionTypes?.length)
			this.consentConditionTypes = [
				{ text: 'Select a consent condition type..', value: null, disabled: true },
				...consentConditionTypes.map(consentConditionType => ({
					text: consentConditionType.title,
					value: consentConditionType,
				})),
			];
		this.watchConsentCondition();
	}

	@Watch('consentCondition')
	public watchConsentCondition() {
		this.consentConditionType = this.consentCondition.consentconditiontype ?? null;
		this.isEditing = this.consentCondition.consentId != null;
	}

	@Emit('saved')
	public onSaved(consentCondition: ConsentCondition): ConsentCondition {
		return consentCondition;
	}

	protected notValid(): boolean {
		return !this.formValid || this.consentConditionType == null;
	}

	protected async submit(event: Event): Promise<void> {
		event.preventDefault();
		const conditionForm = <WaterConsentConditionType<any> | null>this.$refs?.conditionType;
		if (conditionForm == null || this.consentConditionType == null) return;

		const data: ConsentConditionWithParams = {
			...(this.consentCondition ?? {}),
			consentId: this.consent.id,
			consentconditiontype: this.consentConditionType,
			consentConditionTypeId: this.consentConditionType.id,
			parameters: conditionForm.getParameters(),
		};
		try {
			const saved = (
				await this.consentConditionModule.save(data, this.consentCondition?.id ?? undefined)
			).data;
			this.$bvModal.hide(this.modalId);
			if (saved) this.onSaved(saved);
		} catch (e) {
			const { errorMessage } = ApiUtils.handleApiError(
				e,
				'There was an issue saving the consent condition',
			);
			this.toast.makeToast(errorMessage, 'Error', 'danger');
		}
	}
}
